<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="机构名称：" prop="orgname">
                <el-input v-model="model.orgname"></el-input>
            </el-form-item>
            <el-form-item label="排序：" prop="pxorder">
                <el-input v-model.number="model.pxorder"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: "orgEdit",
    mixins: [editutil],
    props: {
        pid: {
            type: Number,
            default() {
                return 0
            }
        }
    },
    data() {
        return {
            exits_p_name:'orgname',
            exits_p_title:'机构名称',
            model: {
                orgname: '',
                pxorder: '',
            },
            getObj:{
                url:'/api/admin/org/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            checkObj:{
                url:'/api/admin/org/check',
                data:{
                    key:'',
                    value:''
                }
            },
            rules: {
                orgname: [
                    {required: true, message: '用户名不能为空', trigger: 'blur'},
                    {validator: this.validOrgExist, trigger: 'blur' }
                ],
                pxorder: [
                    {required: true, message: '排序不能为空', trigger: 'blur'},
                    {type: 'number', message: '排序必须是数字值', trigger: 'blur'}
                ],
            }
        }
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/org/save'
                    }
                    this.model.pid = this.pid
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                    
                }
            })
        }
    }
};
</script>